export const checkFakeToken = (error: any) => {
  if (!error || !error.response) {
    return;
  }

  const { error: errorMessage } = error.response.data || {};
  const statusCode: number = error.response.status || 0;
  if (
    !errorMessage ||
    (errorMessage !== "logout" &&
      errorMessage !== "Token empty or invalid" &&
      errorMessage !== "invalid signature" &&
      statusCode !== 400)
  ) {
    return;
  }

  localStorage.clear();
  localStorage.removeItem("authToken");
  window.location.reload();
};
